import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ContextComponent from "../../../../../AppContext";

import DataTable from "../../../../../controls/table/DataTable";
import AddIcon from "../../../../../../assets/img/add.png";
import EditIcon from "../../../../../../assets/img/Edit.png";
import SaveIcon from "../../../../../../assets/img/Save.png";
import DeleteIcon from "../../../../../../assets/img/Delete.png";

import EmptyPage from "../../../../../pages/EmptyPage";
import Utils from "../../../../../Utils";
import { Button, Modal } from "react-bootstrap";
import AddLinkPage from "./AddLinkPage";
import EditLinkPage from "./EditLinkPage";

function LinksPage() {
  const { siteid } = useParams();
  let { setCanRedirectToLogin, setLoadingState, setAlert, userData } =
    useContext(ContextComponent);

  const [admin, setAdmin] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [moderator, setModerator] = useState(false);

  const [currSiteId, setCurrSiteId] = useState(siteid);
  const [siteName, setSiteName] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItemCount, setSelectedItemCount] = useState(0);

  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  const [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
  const [saveIconClass, setSaveIconClass] = useState(DISABLED_ICON);

  const [tableSelectedItems, setTableSelectedItems] = useState([]);
  const [linkForEdit, setLinkIdForEdit] = useState("");
  const [allLinks, setAllLinks] = useState([]);
  const navigate = useNavigate();
  const isQuiz = Utils?.getQuizSurveyMapValue(siteid);
  const isUpdatedView = Utils?.getUpdatedViewMapValue(siteid);

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
      setLinkIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);
      setLinkIdForEdit("");
    }
  }, [tableSelectedItems]);

  useEffect(() => {
    setAdmin(!!userData?.admin);
    setSuperAdmin(!!userData?.superAdmin);
    setModerator(userData?.roles?.includes("ROLE_MODERATOR") || false);
  }, [admin, superAdmin, moderator, userData]);

  let [editModalCanOpen, setEditModalCanOpen] = useState(false);
  const [editableLink, setEditableLink] = useState({});
  const [editableLinkIndex, setEditableLinkIndex] = useState(-1);

  const openEditModal = (e) => {
    e.preventDefault();
    setEditModalCanOpen(true);
    let targetLink = {};
    allLinks.forEach((linkItem, index) => {
      if (linkItem.id === linkForEdit) {
        targetLink = linkItem;
        setEditableLinkIndex(index);
      }
    });
    //console.log(targetUser);
    !Utils.isObjectEmpty(targetLink) && setEditableLink(targetLink);
  };

  let tableColumns = isUpdatedView
  ? ["id", "select", "linkCode", "title", "description", "type", "order"]
  : [
      "id",
      "select",
      "linkCode",
      "title",
      "description",
      "linkText",
      "type",
      "order",
    ];

  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
    },
    linkCode: {
      type: "hidden",
      search: false,
      sort: false,
      title: "Link Code",
    },
    title: {
      type: "text",
      search: false,
      sort: false,
      title: "Title",
    },
    description: {
      type: "text",
      search: false,
      sort: false,
      title: "Description",
    },
    linkText: {
      type: "text",
      search: false,
      sort: false,
      title: "Alt Text",
    },
    type: {
      type: "text",
      search: false,
      sort: false,
      title: "Link Type",
    },
    order: {
      type: "order",
      search: false,
      sort: true,
      title: "Order",
    },
  });

  let [tableData, setTableData] = useState([]);
  const [canRender, setCanRender] = useState(false);
  const [renderDataTable, setRenderDataTable] = useState(false);
  const [renderEmptyPage, setRenderEmptyPage] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);

  const [orderChanged, setOrderChanged] = useState({});
  const [addDisabled, setAddDisabled] = useState(false);

  const getLinkNameFromValue = (value) => {
    const fieldTypeObj = Utils.LINK_TYPE.find(field => field.value === value);
    return fieldTypeObj ? fieldTypeObj.name : "";
  }

  const updateTableData = (data) => {
    setAllLinks(data);
    let LinkInfo = data;
    let LinksArray = [];
    if (!Utils.isObjectEmpty(LinkInfo)) {
      LinksArray = LinkInfo.map((linkData, index) => {
        let linkTableObj = [];
        let linkTableData = [];
        tableColumns.forEach((col) => {
          if (col === "select") {
            linkTableData.push(false);
          } else if (col === "type") {
            let tempValue = LinkInfo?.[index]?.['type'];
            let valueToBePush = getLinkNameFromValue(tempValue);
            linkTableData.push(valueToBePush);
          } else {
            linkTableData.push(LinkInfo[index][col]);
          }
        });
        linkTableObj = linkTableData;
        return linkTableObj;
      });
      let name = data[0]?.siteName ?? '';
      name.length > 0 && setSiteName("(" + name + ")");
      setTableData(LinksArray);
      // setCanRender(true);
    }
    setCanRender(true);
  };

  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    updateTableData(res.data);

    setRenderDataTable(res.data.length !== 0);
    setRenderEmptyPage(res.data.length === 0);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadFreshLinks = (currSiteId) => {
    Utils.getAllLinksBySitedId({ siteId: currSiteId }).then(success, fail);
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading links",
    });
    loadFreshLinks(currSiteId);
  }, []);

  useEffect(() => {
    if (tableData.length) {
      // console.log("table has data now");
    }
  }, [tableData]);

  useEffect(() => {
    setAddDisabled(tableData.length >= 3 && isQuiz);
  }, [tableData, isQuiz]);


  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setAlert({
      show: true,
      message: "Field(s) deleted successfully",
      type: "success"
    });
    setTableSelectedItems([]);
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
    setAlert({
      show: true,
      message: "Field(s) deletion failed",
      type: "danger",
    });

  };

  const handleDelete = async (e) => {
    setShowDeleteModal(false);
    // setLoadingState({
    //   applyMask: true,
    //   text: "Deleting selected " + tableSelectedItems.length + " items",
    // });
    // Refactored to ensure that order is reset after deletion
    let tempTableData = tableData
      .filter((d) => tableSelectedItems.indexOf(d[0]) === -1)
      .map((row, i) => {
        let orderIndex = tableColumns.indexOf("order");
        row[orderIndex] = i + 1; // reset order starting from 1
        return row;
      });
    setTableData(tempTableData);
    Utils.deleteLinks(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  const [addModalCanOpen, setAddModalCanOpen] = useState(false);

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };

  const closeAddModal = (e) => {
    setAddModalCanOpen(false);
  };

  useEffect(() => {
    if (Object.keys(orderChanged).length > 0) {
      let action = orderChanged.action;
      // let currentIdx = (parseInt(orderChanged.current, 10)) - 1;
      let currentIdx = parseInt(orderChanged.current, 10); // changed to rowIndex so zero-based
      let targetIdx = action === "plus" ? currentIdx + 1 : currentIdx - 1;

      setOrderChanged({});

      let orderIndex = tableColumns.indexOf("order");

      // deep clone the table data
      let currentTableDataTemp = JSON.parse(JSON.stringify(tableData));

      // swap rows
      let temp = currentTableDataTemp[currentIdx];
      currentTableDataTemp[currentIdx] = currentTableDataTemp[targetIdx];
      currentTableDataTemp[targetIdx] = temp;

      // update the order property
      currentTableDataTemp.forEach((row, i) => {
        row[orderIndex] = i + 1; // order starts from 1
      });

      setTableData(currentTableDataTemp);
      setSaveIconClass("");
    }

  }, [orderChanged]);

  const handleSaveOrder = (e) => {
    // console.log("in handleSaveOrder...");
    // console.log(tableData);

    setLoadingState({
      applyMask: true,
      text: "Saving order",
    });

    const saveOrderSuccess = (res) => {
      setLoadingState({
        applyMask: false,
      });
      setAlert({
        show: true,
        message: res?.data?.message
          ? res.data.message
          : "Order saved successfully!",
        type: "success",
      });
      setSaveIconClass(DISABLED_ICON);
    };

    const saveOrderFail = (err) => {
      setLoadingState({
        applyMask: false,
      });
      err?.message?.length && console.log(err);
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: err?.data?.message
          ? err.data.message
          : "Order save failed",
        type: "danger",
      });
    };

    let orderObj = [];
    tableData.forEach((item) => {
      orderObj.push(item[0]);
    });

    Utils.saveOrderForSiteLinks({ siteId: siteid, orderObj }).then(saveOrderSuccess, saveOrderFail);

  }

  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        <span>Links <span className="indi-site-name-in-header">{siteName}</span></span>
        <div className="d-none1 w-50 indi-body-actions">
          {(admin || superAdmin || moderator) && (
            <div
              className={`indi-body-action ${addDisabled ? DISABLED_ICON : ""}`}
              role="button"
              onClick={openAddModal}
            >
              <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
              Add
            </div>
          )}
          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>
          <div
            className={`indi-body-action ${saveIconClass}`}
            role="button"
            onClick={handleSaveOrder}
          >
            <img className="indi-w-20" src={SaveIcon} alt="save-icon"></img>
            Save
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>
        </div>
      </div>
      {canRender && (
        <>
          {renderDataTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
                setOrderChanged,
              }}
            />
          )}
          {!renderDataTable && (
            <EmptyPage
              props={{
                emptyMessage: "No Links are available",
              }}
            />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete select {selectedItemCount} item(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addModalCanOpen && (
        <AddLinkPage
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            tableData,
            setTableData,
            loadFreshLinks,
            isUpdatedView
          }}
        />
      )}
      {editModalCanOpen && (
        <EditLinkPage
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            tableData,
            setTableData,
            editableLink,
            editableLinkIndex,
            allLinks,
            setAllLinks,
            loadFreshLinks,
            isUpdatedView
          }}
        />
      )}
    </div>
  );
}

export default LinksPage;
